module.exports = __webpack_public_path__ + "static/media/Daily Emails for Assigned Task.09775a47.png";